import { useEffect, useState } from "react";
import { CiMail } from "react-icons/ci";
import { FaLock } from "react-icons/fa";
import "./signup.scss";
import { useDispatch } from "react-redux";
import { signupAdmin } from "../../store/slices/Auth/Login/thunk";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { Button } from "@mui/material";
import Spinner from "react-bootstrap/esm/Spinner";
import forcardbg from "../../assets/map.jpg";
import webimg from "../../assets/weblogo.png";
import { IoMdMail } from "react-icons/io";

const Signup = () => {
    const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [loading , setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      navigate("/dashboard");
    }
  }, []); 

  const handleSignup = async () => {
    // e.preventDefault();
    setLoading(true);
    try {
      if(!name || !email || !password){
        toast.error("Please fill all the fields");
        setLoading(false);
        return;
      }
      const result: any = await dispatch(signupAdmin(name,email, password));
      if (result.success) {
        toast.error(result.message || "Admim Sign Up SuccessFully");
        navigate("/login");
      } else {
        toast.error(result.message || "Sign Up failed: Invalid email or password");
      }
    } catch (err: any) {
      // debugger;
      toast.error("Sign Up failed");
      setLoading(false);
    } finally {
      // debugger;
      setLoading(false);
    }
  };
return (
       <>
      <div className="main-Content" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${forcardbg})`, backgroundSize: 'cover', height: '100vh',objectFit:'cover'}}>
        <div className="carD">
          <div className="d-flex justify-content-center">
          <img src={webimg} />
          </div>
          <h1>Sign Up</h1>
          <h6>Welcome back!</h6>
          <h3>Fleet Management System</h3>
              <div className="input" style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <span  style={{
          position: "absolute",
          right: "10px",
          cursor: "pointer",
          color: "#888",
        }}>
            {/* <CiMail /> */}
            <IoMdMail />

            </span>
          </div>
          <div className="input" style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <span  style={{
          position: "absolute",
          right: "10px",
          cursor: "pointer",
          color: "#888",
        }}>
            {/* <CiMail /> */}
            <IoMdMail />

            </span>
          </div>
       <div className="input" style={{ position: "relative", display: "flex", alignItems: "center" }}>
      <input
        type={showPassword ? "text" : "password"}
        placeholder="***"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ paddingRight: "30px" }} // space for icon
      />
      <span
        onClick={() => setShowPassword((prev) => !prev)}
        style={{
          position: "absolute",
          right: "10px",
          cursor: "pointer",
          color: "#888",
        }}
      >
        {showPassword ? <IoEyeOff /> : <IoEye />}
      </span>
    </div>
          <div className="signIn">
             <Button  onClick={handleSignup} disabled={loading} style={{ textTransform: "none" }}>
    {loading ? (
      <>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
          className="me-2"
        />
       {"Sign Up..."}
      </>
    ) : (
      "Sign Up"
    )}
  </Button>
               <Button  onClick={() => navigate('/login')} disabled={loading} style={{ textTransform: "none" }}>Login</Button>
          </div>
          
    </div>
          <ToastContainer />
          {/* {error && <div style={{ color: 'red' }}>{error}</div>} */}
        </div>
      
    </>
  )
}

export default Signup
